import { useGuideStore } from "@/stores/Guide";
import {linkItems} from "@/components/Header/types";
import { type RouteLocationNormalized } from 'vue-router';

const { setIsFromRoutePlayer } = useGuideStore();

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
	if (!import.meta.client || !to || !from) {
        return;
    }
	setIsFromRoutePlayer(from.path === linkItems.player.routerPath);
});